export default "__VITE_ASSET__Cw6EoJ61__"